import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { CollectionService } from 'app/collection/collection.service';
import { Services, Logo } from 'app/constants';
import { Subscription } from 'rxjs';
import { UtilsService } from '../utils.service';

const constValues = {
  green: {
    value: 'green',
    color: '#18D360',
    svgName: 'right-tick',
  },
  red: {
    value: 'red',
    color: '#F75F57',
    svgName: 'x-icon-type2',
  },
  grey: {
    value: 'grey',
    color: '#C5C9D1',
    svgName: 'exclamation-mark',
  },
};

@Component({
  selector: 'cygov-logo-status-card',
  templateUrl: './logo-status-card.component.html',
  styleUrls: ['./logo-status-card.component.scss'],
  standalone: false,
})
export class LogoStatusCardComponent implements OnInit, OnChanges, OnDestroy {
  @Input() width = '9vw';
  @Input() height = '9.5vh';
  @Input() backgroundColor = '';
  @Input() statusCircleWidth = '1vw';
  @Input() status = 'green';
  @Input() logo = 'rapid7-logo';
  @Input() isSVG = true;
  @Input() isDisable: boolean = false;
  @Input() integrationName = '';
  @Input() showAllBadge: boolean = false;
  toolTipMsg: string;
  loading: boolean;
  statusCircleIcon: string;
  statusCircleColor: string;
  toolTipClass: string;
  disabledIntegrations = ['paloalto_logo'];
  subscription: Subscription;

  constructor(private collectionService: CollectionService) {}

  ngOnChanges(changes: SimpleChanges): void {
    // Status arrives async (EntityIntegration mappings fetch) after first render —
    // recompute the circle when the input updates, not just on init.
    if (changes.status && !changes.status.firstChange) {
      this.getStatusCircleColor();
    }
  }

  ngOnInit() {
    this.loading = true;
    this.getStatusCircleColor();
    if (this.disabledIntegrations.map(c => c.toLowerCase()).includes(this.logo.toLowerCase())) {
      this.isDisable = true;
    }
    this.loading = false;

    this.subscription = this.collectionService.updateIntegrationTabs$.subscribe((updatedEntity: any) => {
      if (this.logo === Logo.TENABLE && updatedEntity?.integrations) {
        const tenableIndex = UtilsService.findIndexBasedOnKey(updatedEntity.integrations, 'name', Services.TENABLE);
        if (tenableIndex > -1) {
          this.status = updatedEntity.integrations[tenableIndex].status;
          this.getStatusCircleColor();
        }
      }
    });
  }

  getStatusCircleColor() {
    switch (this.status) {
      case constValues.green.value:
        this.statusCircleColor = constValues.green.color;
        this.statusCircleIcon = constValues.green.svgName;
        this.toolTipClass = constValues.green.value;
        this.toolTipMsg = '';
        break;
      case constValues.red.value:
        this.statusCircleColor = constValues.red.color;
        this.statusCircleIcon = constValues.red.svgName;
        this.toolTipClass = constValues.red.value;
        this.toolTipMsg = 'Please Check Settings';
        break;
      case constValues.grey.value:
        this.statusCircleColor = constValues.red.color;
        this.statusCircleIcon = constValues.grey.svgName;
        this.toolTipClass = constValues.grey.value;
        this.toolTipMsg = 'Service is not running';

        break;
      default:
        this.statusCircleColor = 'unset';
        this.statusCircleIcon = 'none';
        this.toolTipMsg = 'None';
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
